/** Demo feed when API is empty or unavailable. `EN` is used on the public English site; Nordic locales remain for B2B samples. */

function iso(minsAgo = 0) {
  return new Date(Date.now() - minsAgo * 60 * 1000).toISOString();
}

export const initialNews = [
  {
    id: "NEWS-001",
    category: "TRANSFER",
    imageUrl:
      "https://images.unsplash.com/photo-1574629810360-7efbbe195018?auto=format&fit=crop&w=1200&q=80",
    date: iso(0),
    locales: {
      EN: {
        title: "CONFIRMED: MBAPPÉ MOVES TO REAL MADRID",
        excerpt:
          "Sources close to the club confirm all documents are signed. The official presentation is expected after the Champions League final.",
        content:
          "The French superstar has finally put pen to paper with the Spanish giants. After months of speculation, the deal is done.",
      },
      DA: {
        title: "BEKRÆFTET: MBAPPÉ SKIFTER TIL REAL MADRID",
        excerpt:
          "Kilder tæt på klubben bekræfter, at alle dokumenter er underskrevet. Den officielle præsentation forventes efter Champions League-finalen.",
        content:
          "Den franske superstjerne har endelig sat sin underskrift hos de spanske mestre. Efter måneders spekulation er aftalen nu på plads.",
      },
      NB: {
        title: "BEKREFTET: MBAPPÉ GÅR TIL REAL MADRID",
        excerpt:
          "Kilder nær klubben bekrefter at alle dokumenter er signert. Den offisielle presentasjonen ventes etter Champions League-finalen.",
        content:
          "Den franske superstjernen har endelig satt pennen til papiret hos de spanske gigantene. Etter måneder med spekulasjoner er avtalen i boks.",
      },
      SV: {
        title: "BEKRÄFTAT: MBAPPÉ KLAR FÖR REAL MADRID",
        excerpt:
          "Källor nära klubben bekräftar att alla dokument är signerade. Den officiella presentationen väntas efter Champions League-finalen.",
        content:
          "Den franska superstjärnan har äntligen skrivit på för de spanska jättarna. Efter månader av spekulationer är affären nu klar.",
      },
    },
  },
  {
    id: "NEWS-002",
    category: "NEWS",
    imageUrl:
      "https://images.unsplash.com/photo-1543351611-58f69d7c1781?auto=format&fit=crop&w=1200&q=80",
    date: iso(30),
    locales: {
      EN: {
        title: "INJURY UPDATE: LIVERPOOL DEFENCE HIT",
        excerpt:
          "Klopp will be without two key players for the coming weeks after yesterday's match. The medical team is working to have them ready for the cup final.",
        content:
          "It is a major blow for Liverpool in the title race. The back line must be reorganised before the weekend fixture.",
      },
      DA: {
        title: "SKADESUPDATE: LIVERPOOLS FORSVAR RAMT",
        excerpt:
          "Klopp må undvære to nøglespillere i de kommende uger efter gårsdagens kamp. Det medicinske team arbejder på at få dem klar til cupfinalen.",
        content:
          "Det er et hårdt slag for Liverpool i toppen af tabellen. Forsvaret skal reorganiseres før weekendens opgør.",
      },
      NB: {
        title: "SKADEOPPDATERING: LIVERPOOL-FORSVARET HARDT RAMMET",
        excerpt:
          "Klopp må klare seg uten to nøkkelspillere de neste ukene etter gårsdagens kamp. Medisinsk stab jobber for å få dem klare til cupfinalen.",
        content:
          "Dette er et stort tap for Liverpool i toppen av tabellen. Forsvaret må reorganiseres før helgens kamp.",
      },
      SV: {
        title: "SKADEUPPDATERING: LIVERPOOLS FÖRSVAR DRABBAT",
        excerpt:
          "Klopp får klara sig utan två nyckelspelare de kommande veckorna efter gårdagens match. Medicinteamet jobbar för att få dem redo till cupfinalen.",
        content:
          "Detta är ett tungt slag för Liverpool i toppen av tabellen. Försvaret måste ställas om inför helgens match.",
      },
    },
  },
  {
    id: "NEWS-003",
    category: "FINANCE",
    imageUrl:
      "https://images.unsplash.com/photo-1522778119026-d647f0596c20?auto=format&fit=crop&w=1200&q=80",
    date: iso(120),
    locales: {
      EN: {
        title: "NEW TV DEAL FOR PREMIER LEAGUE",
        excerpt:
          "Rights holders have agreed a record deal that delivers significantly higher revenue for clubs over the next four years.",
        content:
          "The agreement gives financial stability for smaller clubs while the biggest sides can plan for larger transfer budgets.",
      },
      DA: {
        title: "NY TV-AFTALE FOR PREMIER LEAGUE",
        excerpt:
          "Rettighedshavere har indgået en historisk aftale med markant højere indtægter til klubberne over de næste fire år.",
        content:
          "Aftalen giver økonomisk ro for mindre klubber, mens de største kan se frem til endnu større transferbudgetter.",
      },
      NB: {
        title: "NY TV-AVTALE FOR PREMIER LEAGUE",
        excerpt:
          "Rettighetshavere har signert en historisk avtale som sikrer betydelig høyere inntekter for klubbene de neste fire årene.",
        content:
          "Avtalen gir økonomisk stabilitet for mindre klubber, mens gigantene kan se frem mot enda større overgangssummer.",
      },
      SV: {
        title: "NYTT TV-AVTAL FÖR PREMIER LEAGUE",
        excerpt:
          "Rättighetsinnehavare har tecknat ett historiskt avtal som ger klubbarna betydligt högre intäkter de kommande fyra åren.",
        content:
          "Avtalet ger ekonomisk stabilitet för mindre klubbar medan jättarna kan se fram emot ännu större transferbudgetar.",
      },
    },
  },
  {
    id: "NEWS-004",
    category: "CLUB NEWS",
    imageUrl:
      "https://images.unsplash.com/photo-1517466787929-bc90951d0974?auto=format&fit=crop&w=1200&q=80",
    date: iso(240),
    locales: {
      EN: {
        title: "FCK EXTEND YOUNG TALENT'S CONTRACT",
        excerpt:
          "The 18-year-old midfielder has signed a new five-year deal after a strong debut at the national stadium.",
        content:
          "The club has tied down one of Scandinavia's most sought-after players despite strong interest from abroad.",
      },
      DA: {
        title: "FCK FORLÆNGER MED UNGT TALENT",
        excerpt:
          "Den 18-årige midtbanespiller har underskrevet en ny 5-årig kontrakt efter en stærk debut på nationalstadion.",
        content:
          "Klubben sikrer sig en af Skandinaviens mest eftertragtede spillere på trods af stor interesse fra udlandet.",
      },
      NB: {
        title: "FCK FORLENGER MED UNG PROSPEKT",
        excerpt:
          "Den 18 år gamle midtbanespilleren har signert en ny femårskontrakt etter en sterk debut på nasjonalarenaen.",
        content:
          "Klubben sikrer en av Skandinavias mest ettertraktede spillere til tross for stor interesse fra utlandet.",
      },
      SV: {
        title: "FCK FÖRLÄNGER MED UNGT LOVANDE",
        excerpt:
          "Den 18-årige mittfältaren har skrivit på ett nytt femårskontrakt efter en stark debut på nationalarenan.",
        content:
          "Klubben säkrar en av Skandinaviens mest eftertraktade spelare trots stort intresse från utlandet.",
      },
    },
  },
  {
    id: "NEWS-005",
    category: "OFFICIAL",
    imageUrl:
      "https://images.unsplash.com/photo-1431324155629-1a6eda1dec2d?auto=format&fit=crop&w=1200&q=80",
    date: iso(480),
    locales: {
      EN: {
        title: "VAR RULES TO CHANGE FROM NEXT SEASON",
        excerpt:
          "The referees' committee will introduce new handball guidelines to create more clarity and fewer stoppages.",
        content:
          "Officials say the changes should make the game flow better and reduce frustration for players and fans.",
      },
      DA: {
        title: "VAR-REGLER ÆNDRES FRA NÆSTE SÆSON",
        excerpt:
          "Dommerkomitéen indfører nye retningslinjer for hånd for at skabe mere klarhed og færre afbrydelser i spillet.",
        content:
          "De nye regler skal gøre spillet mere flydende og mindske frustration hos spillere og fans.",
      },
      NB: {
        title: "VAR-REGLER ENDRES FRA NESTE SESONG",
        excerpt:
          "Dommerkomiteen innfører nye retningslinjer for hånd for å skape mer klarhet og færre avbrudd i spillet.",
        content:
          "De nye reglene skal gjøre spillet mer flytende og redusere frustrasjon hos spillere og supportere.",
      },
      SV: {
        title: "VAR-REGLER ÄNDRAS FRÅN NÄSTA SÄSONG",
        excerpt:
          "Domarkommittén inför nya riktlinjer för hands för mer tydlighet och färre avbrott i spelet.",
        content:
          "De nya reglerna ska göra spelet mer flytande och minska frustrationen hos spelare och supportrar.",
      },
    },
  },
];